import { FilterOptionKeys, SortingMode, TaskGroupBy } from '@griply/types';

// Upcoming is always grouped by deadline — no group selector on either platform
export const upcomingGroupOptions = [] as const satisfies TaskGroupBy[];

export const upcomingFilters = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Goal,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Duration,
  FilterOptionKeys.Priority,
] as const satisfies FilterOptionKeys[];

export const upcomingSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];
